import React, { useState } from 'react'
import './index.scss'
import FieldValidation from "./fieldValidation";
import { submitJobApplication } from "../../api/jobApplications";

const ContactForm = ({
                         expectAttachment = false
                     }: {
    expectAttachment?: boolean
}) => {

    const [name, setName] = useState('');
    const [nameTouched, setNameTouched] = useState(false);

    const [email, setEmail] = useState('');
    const [emailTouched, setEmailTouched] = useState(false);

    const [errand, setErrand] = useState('');

    const [msg, setMsg] = useState('');
    const [msgTouched, setMsgTouched] = useState(false);

    const [files, setFiles] = useState<File[]>([]);
    const [fileInputKey, setFileInputKey] = useState(0);

    const [isSubmitting, setIsSubmitting] = useState(false);

    const [feedback, setFeedback] = useState<{
        type: 'success' | 'error';
        message: string;
    } | null>(null);

    const validateEmail = (email: string) => {
        const regex =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        return regex.test(email);
    };

    const nameValid = name.length > 4;
    const emailValid = validateEmail(email);
    const msgValid = msg.length > 4;

    const formValid =
        nameValid &&
        emailValid &&
        msgValid;

    const handleFileChange = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        if (e.target.files) {
            setFiles(Array.from(e.target.files));
        }
    };

    const clearForm = () => {
        setName('');
        setEmail('');
        setErrand('');
        setMsg('');
        setFiles([]);

        setNameTouched(false);
        setEmailTouched(false);
        setMsgTouched(false);

        // Reset the actual <input type="file">
        setFileInputKey(key => key + 1);
    };

    async function send() {
        if (!formValid || isSubmitting) {
            return;
        }

        setIsSubmitting(true);
        setFeedback(null);

        // Save this before clearing the form
        const hasAttachments = files.length > 0;

        try {
            await submitJobApplication({
                contact: {
                    name,
                    email
                },
                msg,
                errand,
                cvList: files,
            });

            clearForm();

            setFeedback({
                type: 'success',
                message: hasAttachments
                    ? 'Tack för din ansökan, vi tittar på den och återkommer.'
                    : 'Tack för ditt mail!'
            });

        } catch (error) {
            console.error(
                'Failed to submit contact form',
                error
            );

            setFeedback({
                type: 'error',
                message: 'Något gick fel'
            });
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <div className='contactForm'>

            <h5>Ditt namn</h5>
            <input
                value={name}
                onChange={e => {
                    setName(e.target.value);
                    setFeedback(null);
                }}
                onBlur={() => setNameTouched(true)}
            />

            <FieldValidation
                valid={!nameTouched || nameValid}
            />

            <h5>Din email-address</h5>
            <input
                value={email}
                onChange={e => {
                    setEmail(e.target.value);
                    setFeedback(null);
                }}
                onBlur={() => setEmailTouched(true)}
            />

            <FieldValidation
                valid={!emailTouched || emailValid}
            />

            {expectAttachment && (
                <div>
                    <h5>CV</h5>

                    <div className='file-selector'>
                        <input
                            key={fileInputKey}
                            type='file'
                            onChange={handleFileChange}
                            multiple
                        />
                    </div>
                </div>
            )}

            {!expectAttachment && (
                <div>
                    <h5>Ämne</h5>

                    <input
                        value={errand}
                        onChange={e => {
                            setErrand(e.target.value);
                            setFeedback(null);
                        }}
                    />
                </div>
            )}

            <h5>Meddelande</h5>

            <textarea
                value={msg}
                onChange={e => {
                    setMsg(e.target.value);
                    setFeedback(null);
                }}
                onBlur={() => setMsgTouched(true)}
            />

            <FieldValidation
                valid={!msgTouched || msgValid}
            />

            <div className='sendButton'>
                <button
                    className='button button4'
                    type="button"
                    onClick={send}
                    disabled={!formValid || isSubmitting}
                >
                    {isSubmitting
                        ? 'Skickar...'
                        : 'Skicka meddelande'}
                </button>
            </div>

            {feedback && (
                <p
                    className={
                        feedback.type === 'success'
                            ? 'submitFeedback submitSuccess'
                            : 'submitFeedback submitError'
                    }
                >
                    {feedback.message}
                </p>
            )}

        </div>
    )
}

export default ContactForm;